import { FetchError } from '@api/client';

export const errorInterceptor = (error: unknown): never => {
  if (error instanceof FetchError) {
    throw error;
  }

  throw new Error('Auth service: Unknown error', {
    cause: error,
  });
};
